import { render, staticRenderFns } from "./CustomerActivityImapEmail.vue?vue&type=template&id=597b4612&"
import script from "./CustomerActivityImapEmail.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityImapEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports